import MembershipGrowthChartView from "../../features/MetabaseDashboard/MembershipGrowthChartView";

const MembershipGrowthChart = () => {
  return (
    <div>
     <MembershipGrowthChartView />
    </div>
  );
};

export default MembershipGrowthChart;
